import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const DunningsBulletPoint = ({ text }: { text: string }) => (
    <Flex
        gap="4px"
        alignItems="center"
    >
        <SWReactIcons
            iconName="checked"
            size="xs"
            iconColor={colorsPalettes.blue[300]}
        />
        <Text fontVariant="body2">{text}</Text>
    </Flex>
);
